import {mediaTypeValues} from './MediaType';

export const MediaRouteConfig = [
    // {
    //     path: '/apps/:appId/media',
    //     exact: true,
    //     component: require('./pages/NewsPage').default,
    // },
    ...mediaTypeValues,
];

export const MenuConfig = MediaRouteConfig.filter(item => !!item.label);
